import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asbmcbusinessstudies',
  templateUrl: './asbmcbusinessstudies.component.html',
  styleUrls: ['./asbmcbusinessstudies.component.scss']
})
export class AsbmcbusinessstudiesComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
